import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import StripePaymentOptionComponent from '../booking/paymentMethods/Stripe/PaymentOptionComponent';
import TakepaymentsPaymentOptionComponent from '../booking/paymentMethods/Takepayments/PaymentOptionComponent';

class PaymentOptionComponent extends Component {
	getPaymentOptionComponentByMethod() {
		const { payment: { paymentMethod } } = this.props;

		switch (paymentMethod.name) {
			case 'Stripe':
				return <StripePaymentOptionComponent {...this.props} />;
			case 'Takepayments':
				return <TakepaymentsPaymentOptionComponent  {...this.props} />;
			default:
				return null;
		}
	}

	render() {
		return this.getPaymentOptionComponentByMethod();
	}
}

export default withTranslation()(PaymentOptionComponent);